
import React from "react";
import {
  AlertDialogCancel,
  AlertDialogAction,
} from "@/components/ui/alert-dialog";
import { Edit, Sparkles } from "lucide-react";

interface WelcomeDialogFooterProps {
  activeTab: string;
  onCreateSermon: () => void;
}

export function WelcomeDialogFooter({ activeTab, onCreateSermon }: WelcomeDialogFooterProps) {
  return (
    <div className="w-full flex flex-col sm:flex-row gap-2">
      <AlertDialogCancel className="w-full sm:w-auto mt-0">Cancel</AlertDialogCancel>
      <AlertDialogAction 
        onClick={(e) => {
          e.preventDefault();
          onCreateSermon();
        }} 
        className="w-full sm:w-auto flex items-center justify-center"
      >
        {activeTab === "manual" ? (
          <>
            <Edit className="mr-2 h-4 w-4" />
            Create Sermon
          </>
        ) : (
          <>
            <Sparkles className="mr-2 h-4 w-4" />
            Get AI Suggestions
          </>
        )}
      </AlertDialogAction>
    </div>
  );
}
